<template>
  <md-table
    v-model="contacts"
    class="table-striped"
    table-header-color="primary"
  >
    <md-table-row slot="md-table-row" slot-scope="{ item }">
      <md-table-cell md-label="Name">
        {{ item.name }}
      </md-table-cell>
      <md-table-cell md-label="Email">
        {{ item.email }}
      </md-table-cell>
      <md-table-cell md-label="Phone">
        {{ item.phone }}
      </md-table-cell>
    </md-table-row>
    <md-table-empty-state md-label="No Contacts Found"></md-table-empty-state>
  </md-table>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      contacts: "portfolio/clientContacts"
    })
  }
};
</script>

<style></style>
